import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import EquivalentIndels from "./EquivalentIndels";
import DeclarationList from "../../../../components/declaration/DeclareInterestList";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import RenderExplainLink from "../../../../components/atoms/RenderExplainLink/RenderExplainLink";
import {
  getIsSnv,
  getVariantId,
  getVariantResult,
  getVariantResultGenes,
} from "../../../../state/selectors/general.selectors";
import ResearchUseMessage from "./ResearchUseMessage";
import QueryCount from "./QueryCount";
import ExplainMessage from "./ExplainMessage";
import VariantDetailsContent from "./VariantDetailsContent";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import HelperText from "../../../../components/atoms/HelperText";

const VariantDetails = ({ isSnv, variantId, genes }) => {
  const [showingVariantId, setShowingVariantId] = useState(false);
  const [explainVisible, setExplainVisible] = useState(false);

  const handleExplainVisible = (visible) => {
    setExplainVisible(visible);
  };

  const toggleShowingVariantId = () => {
    setShowingVariantId(!showingVariantId);
  };

  if (variantId) {
    const title = (
      <>
        <span
          className="tw-cursor-pointer tw-font-semibold"
          onClick={() => toggleShowingVariantId()}
        >
          Variant
        </span>
        <HelperText fieldDescriptionKey="Variant" />
        {showingVariantId && (
          <span>
            <small className="tw-ml-4">{`id: ${variantId} `}</small>
          </span>
        )}
      </>
    );

    const content = (
      <React.Fragment>
        <div className="varsome-inner-container">
          {isSnv && explainVisible && <ExplainMessage />}
        </div>
        <VariantDetailsContent />
        <QueryCount />
        {!__IS_COMPONENTS_PORTAL__ && (
          <div className="varsome-inner-container">
            <DeclarationList variantId={variantId} genes={genes} />
          </div>
        )}
        <EquivalentIndels />
        {!__IS_COMPONENTS_PORTAL__ && <ResearchUseMessage />}
      </React.Fragment>
    );

    const titleDetailsRight = isSnv ? (
      <RenderExplainLink
        setExplainVisible={handleExplainVisible}
        label="Explain"
      />
    ) : null;

    return (
      <div className="varsome-result-fixed">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            titleDetailsRight={titleDetailsRight}
            content={content}
            title={title}
          />
        </div>
      </div>
    );
  }
  return null;
};

VariantDetails.propTypes = {
  isSnv: PropTypes.bool,
  variant: PropTypes.shape({}),
  variantId: PropTypes.string,
  genes: PropTypes.arrayOf(PropTypes.shape({})),
};

VariantDetails.defaultProps = {
  isSnv: false,
  variant: null,
  variantId: null,
  genes: null,
};

const mapStateToProps = (state) => {
  return {
    isSnv: getIsSnv(state) || false,
    variant: getVariantResult(state),
    variantId: getVariantId(state),
    genes: getVariantResultGenes(state),
  };
};

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(VariantDetails, "VariantDetails", "Variant"));
